import { render, staticRenderFns } from "./MLaporanPenyidikan.vue?vue&type=template&id=9d1682dc&scoped=true&lang=html&"
import script from "./MLaporanPenyidikan.vue?vue&type=script&lang=js&"
export * from "./MLaporanPenyidikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1682dc",
  null
  
)

export default component.exports